import { ArrowUpRight } from "lucide-react"

export default function CtaDashboardSection() {
    return (
        <section className="py-24">
            <div className="mx-auto max-w-7xl px-6">
                <div className="relative overflow-hidden rounded-3xl bg-[#f7f8fd] px-10 py-16">

                    <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">

                        {/* Left Content */}
                        <div>
                            <h2 className="text-3xl sm:text-4xl font-semibold text-foreground leading-tight">
                                Ready to get started?
                            </h2>

                            <p className="mt-4 text-sm text-muted-foreground max-w-md">
                                Transform your recruitment and onboarding with AI-powered efficiency.
                            </p>

                            <div className="mt-8 flex flex-wrap gap-4">
                                <button
                                    onClick={() => window.location.href = '/signup'}
                                    className="inline-flex items-center gap-2 rounded-full bg-blue-900 px-6 py-3 text-sm font-medium text-white hover:bg-blue-800 transition"
                                >
                                    Get Started
                                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-cyan-400 text-blue-900">
                                        <ArrowUpRight size={14} />
                                    </span>
                                </button>

                                <a
                                    href="mailto:info@temperedtalent.com"
                                    className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-6 py-3 text-sm font-medium text-foreground hover:bg-muted transition"
                                >
                                    Book a Demo
                                    <ArrowUpRight size={14} />
                                </a>
                            </div>
                        </div>

                        {/* Right Image */}
                        <div className="relative">
                            <div className="rounded-2xl bg-card p-4 shadow-xl">
                                <img
                                    src="/images/hero.png"
                                    alt="Dashboard Preview"
                                    className="w-full rounded-xl"
                                />
                            </div>
                        </div>

                    </div>

                    {/* Bottom Accent Line */}
                    <div className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-blue-900 to-cyan-400" />

                </div>
            </div>
        </section>
    )
}